module.exports = __webpack_public_path__ + "img/award-bg2.87fc2699.png";